<template>
  <div class="px-5 py-4">
    <div class="flex flex-col">
      <div class="flex flex-col" style="gap:0.5rem;">
        <div class="plusGreyDarken4--text" style="font-size:1.438rem;">{{$t("message.products_memberships_plus.add_product")}}</div>
        <div v-if="!product.type" class="plusGreyDarken2--text">{{$t("message.products_memberships_plus.add_product_explained")}}</div>
      </div>
      <div style="padding-top:1.5rem">
        <v-select v-if="productId == 'new'" :items="types" outlined :label="$t('message.product_type')"
          v-model="productType" dense></v-select>
      </div>
      <div v-if="product.type" class="rounded" style="padding: 1rem; border:1px solid #E0E0E0;">
        <div class="flex flex-col" style="gap:1rem;">
          <div>Product details</div>
          <div class="flex flex-column flex-md-row" style="gap:2rem;">
            <div class="flex flex-col" style="flex:0 0 50%;gap:0.5rem;" v-if="product.type == 'good'">
              <div v-if="!productImage" class="flex flex-col plusGreyLighten5 justify-center items-center" style="gap:1.5rem;height:14.125rem;border:1px dashed #BDBDBD !important;" >
                <div class="plusGreyDarken2--text">{{$t("message.products_memberships_plus.upload_photo_product")}}</div>
                <PlusImageUploadCroppie :vm="this" :success-function="successUploadImage"></PlusImageUploadCroppie>
              </div>
              <div v-if="!productImage" class="text-center plusGreyDarken1--text" style="font-size:0.875rem;">{{$t("message.products_memberships_plus.upload_photo_recommended")}}</div>
              <div v-if="productImage" class="flex flex-col justify-center items-center plusIndigoLighten5 rounded" style="height:100%;gap:1rem;">
                <v-avatar size="250" rounded="0">
                  <ImageDisplay v-if="productImage" :src="productImage" />
                </v-avatar>
                <PlusImageUploadCroppie :vm="this" :success-function="successUploadImage" :label="$t('message.products_memberships_plus.change_image')"></PlusImageUploadCroppie>
              </div>
            </div>
            <div class="flex-grow-1 flex flex-col">
              <v-text-field class="flex-grow-0" outlined dense :label="$t('message.name')" v-model="product.name"></v-text-field>
              <ProductCategories v-if="product.type == 'good'" v-model="product.category"></ProductCategories>
              <v-textarea outlined :label="$t('message.description')" v-model="product.description"></v-textarea>
              <div class="flex" style="gap:1.5rem;">
                  <v-text-field :disabled="this.productId != 'new' && product.type != 'good'" outlined dense
                    :label="$t('message.price')" v-mask="mask1" v-model="price"></v-text-field>
                  <v-text-field :disabled="this.productId != 'new' && product.type != 'good'" outlined dense
                    v-mask="mask2" v-model="priceDecimal"></v-text-field>
                  <v-text-field outlined dense disabled v-model="currencyText"
                    :label="$t('message.currency')"></v-text-field>
              </div>
            </div>
          </div>
        </div>
        <div class="pt-6" v-if="product.type == 'good' && !product.isMembership">
          <v-text-field class="pb-0 mb-0" :disabled="product.unlimited" outlined dense
            :label="$t('message.inventory_quantity') + ' (' + $t('message.optional') + ')'"
            v-model="product.availableQuantity"></v-text-field>
          <v-text-field v-if="product.type == 'good' && !product.isMembership" single-line outlined dense
            :label="$t('message.size') + ' (' + $t('message.optional') + ')'" v-model="product.size"></v-text-field>
          <v-switch color="plusIndigoDarken4" inset v-if="product.type == 'good' && !product.isMembership" v-model="showColorPicker" dense
            :label="$t('message.color') + ' (' + $t('message.optional') + ')'"></v-switch>
          <v-color-picker v-if="product.type == 'good' && showColorPicker && !product.isMembership"
            :hide-mode-switch="true" :hide-inputs="true" mode="hexa" v-model="product.color"></v-color-picker>
          <v-switch color="plusIndigoDarken4" inset class="mt-2 pt-0" dense v-model="product.unlimited"
            :label="$t('message.unlimited_quantity')"></v-switch>
        </div>
        <div class="pt-6" v-if="product.type == 'good' && product.isMembership">
          <v-select :items="months" outlined
            :label="$t('message.membership_months') + ' (' + $t('message.optional').toLowerCase() + ')'"
            v-model="product.membershipMonths" dense clearable
            :disabled="product.membershipDays > 0 || product.membershipCheckins > 0 ? true : false"></v-select>
          <v-text-field type="number" outlined dense
            :label="$t('message.membership_days') + ' (' + $t('message.optional').toLowerCase() + ')'"
            :disabled="product.membershipMonths > 0 || product.membershipCheckins > 0 ? true : false"
            v-model="product.membershipDays">
          </v-text-field>
          <v-text-field type="number" outlined dense hide-details
            :label="$t('message.membership_checkins') + ' (' + $t('message.optional').toLowerCase() + ')'"
            :disabled="product.membershipDays > 0 || product.membershipMonths > 0 ? true : false"
            v-model="product.membershipCheckins">
          </v-text-field>
        </div>
        <v-switch  color="plusIndigoDarken4" inset class="pt-2 mt-0" dense v-if="product.type == 'good'" v-model="product.allowInTablet"
          :label="$t('message.allow_in_tablet')"></v-switch>
        <v-select v-if="productId == 'new' && product.type == 'service'" :items="intervals" outlined dense
          :label="$t('message.frequency')" v-model="product.interval"></v-select>
      </div>

      <div v-if="product.type" class="flex pt-12" :class="{'flex-wrap': isSmallerDisplay()}"  style="gap:1.25rem;">
        <div class="flex" style="gap:1.25rem;" :class="{'flex-wrap': isSmallerDisplay()}">
          <PlusButton large @click="goBack()">{{$t('message.cancel')}}</PlusButton>
          <PlusButton :loading="updating" v-if="product._id" v-allowed="'edit_products'" intent="primary" large
            @click="addEditProduct()" :disabled="!currency ? true : false">{{$t("message.products_memberships_plus.edit_product")}}</PlusButton>
          <PlusButton :loading="updating" v-else v-allowed="'add_products'" intent="primary" large
            @click="addEditProduct()" :disabled="!currency ? true : false">{{$t("message.products_memberships_plus.add_product")}}</PlusButton>
        </div>
        <div>
          <PlusButton :loading="updating" intent="error" v-if="product._id" large
            @click="showDeleteProductDialog()" >{{$t("message.delete")}}</PlusButton>
        </div>
      </div>
      <div v-if="!product.type" class="flex" style="gap:1.25rem;">
        <PlusButton large @click="goBack()">{{$t("message.cancel")}}</PlusButton>
      </div>
    </div>
    <v-dialog v-model="deleteProductDialog" content-class="fit-content">
      <v-card class="pa-2">
        <v-card-text>{{ $t('message.delete_product_confirm') }}</v-card-text>
        <v-card-actions>
          <PlusButton :loading="deletingProduct" intent="error" @click.stop="deleteProduct()">{{
            $t('message.delete') }}</PlusButton>
          <PlusButton elevation="0" @click.stop="deleteProductDialog = false">{{
            $t('message.close')
          }}</PlusButton>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import Api from "@/services/Api";
import Api2 from "@/services/Api2";
import { completeOnboardingStep } from "@/services/onboardingSteps";
import PlusImageUploadCroppie from "@/components/plus/PlusImageUploadCroppie";
import PlusButton from "@/components/plus/PlusButton";
import ProductCategories from "@/components/inputs/ProductCategoriesCombo";
import { mask } from "vue-the-mask";

export default {
  directives: {
    mask,
  },
  data() {
    return {
      loading: true,
      productId: this.$route.params.productId,
      formMessage: null,
      productType: null,
      automaticTaxes: false,
      product: null,
      showColorPicker: false,
      productImage: null,
      currency: null,
      currencyText: null,
      intervalText: null,
      availableClasses: [],
      restrictAttendance: false,
      duplicateProductDialog: null,
      duplicateProduct: null,
      price: null,
      mask1: "########",
      altStripeAccounts: null,
      stripeReady: false,
      paymentsReady: false,
      mask2: "##",
      priceDecimal: "00",
      updating: false,
      goods: [],
      subscriptions: [],
      categories: [],
      managedAcademy: this.$store.state.managedAcademy,
      deleteProductDialog: false,
      contracts: [],
      assignContract: false,
      deletingProduct: false,
      taxCodes: null,
      paymentsModule: null,
      inventory: [],
      loadingInventory: false,
      allowedClassCount: null,
      allowedClassCountInterval: null,
      allowedClassCountSendEmail: false,
      taxBehaviors: {
        exclusive: 'exclusive',
        inclusive: 'inclusive',
        none: null,
      },
      types: [
        { text: this.$t("message.goods"), value: "good" },
        { text: this.$t("message.manual_membership"), value: "good_membership" },
      ],
      intervals: [
      ],
      months: [
        { text: "1 " + this.$t("message.month"), value: 1 },
        { text: "2 " + this.$t("message.months"), value: 2 },
        { text: "3 " + this.$t("message.months"), value: 3 },
        { text: "4 " + this.$t("message.months"), value: 4 },
        { text: "5 " + this.$t("message.months"), value: 5 },
        { text: "6 " + this.$t("message.months"), value: 6 },
        { text: "7 " + this.$t("message.months"), value: 7 },
        { text: "8 " + this.$t("message.months"), value: 8 },
        { text: "9 " + this.$t("message.months"), value: 9 },
        { text: "10 " + this.$t("message.months"), value: 10 },
        { text: "11 " + this.$t("message.months"), value: 11 },
        { text: "12 " + this.$t("message.months"), value: 12 },
        { text: "13 " + this.$t("message.months"), value: 13 },
        { text: "14 " + this.$t("message.months"), value: 14 },
        { text: "15 " + this.$t("message.months"), value: 15 },
        { text: "16 " + this.$t("message.months"), value: 16 },
        { text: "17 " + this.$t("message.months"), value: 17 },
        { text: "18 " + this.$t("message.months"), value: 18 },
        { text: "19 " + this.$t("message.months"), value: 19 },
        { text: "20 " + this.$t("message.months"), value: 20 },
        { text: "21 " + this.$t("message.months"), value: 21 },
        { text: "22 " + this.$t("message.months"), value: 22 },
        { text: "23 " + this.$t("message.months"), value: 23 },
        { text: "24 " + this.$t("message.months"), value: 24 },
      ],
      allowedClassIntervals: [
        { text: this.$t("message.weekly"), value: "week" },
        { text: this.$t("message.monthly"), value: "month" },],
      successUploadImage: function (uploadedFileData, vm) {
        if (vm && uploadedFileData) {
          vm.product.image = uploadedFileData.location;
          vm.productImage = uploadedFileData.original;
        }
      },
      onboardingStepComplete: false
    };
  },
  components: {
    PlusImageUploadCroppie,
    ProductCategories,
    PlusButton,
  },
  created() {
    this.loading = true;
    this.initPage();
    if (this.isAppAdmin())
      this.intervals.unshift({ text: this.$t("message.daily"), value: "day" });
    Api2()
      .post('trial/stepState', { "managedAcademy": this.$store.state.managedAcademy })
      .then((response) => {
        if(response?.data?.setupProductsMemberships) {
          this.onboardingStepComplete = true;
        } 
      }).catch(() => {
        this.onboardingStepComplete = true;
      });
  },
  beforeRouteUpdate(to, from, next) {
    this.productId = to.params.productId;
    this.loading = true;
    this.product = null;
    this.initPage();
    next();
  },
  watch: {
    productType: {
      handler: function (newValue) {
        if (newValue == 'good_membership') {
          this.product.type = 'good';
          this.product.isMembership = true;
          this.product.category = this.$t("message.membership");
          this.product.manualRecurrence = true;
        } else {
          this.product.type = newValue;
          this.product.isMembership = false;
          this.product.category = '';
        }
        this.initTaxCode(this.product);
        console.log({newValue});
      },
    },
    showColorPicker: {
      handler: function (newValue) {
        if (!newValue) this.product.color = null;
      },
    },
  },
  methods: {
    initPage() {
      this.loading = true;
      if (this.$store.state.managedAcademy) {
        Api()
          .get(
            "admins/academy/" +
            this.$store.state.managedAcademy +
            "/is_connected/all"
          )
          .then((response) => {
            this.stripeReady = response.data.stripeConnected;
            this.paymentsModule = response.data.paymentsModule;
            this.paymentsReady = response.data.paymentsReady;
            if (this.stripeReady || response.data.paymentsReady) {
              this.types.push(
                { text: this.$t("message.recurrent_subscription"), value: "service" });
              if (this.paymentsModule == 'stripe') {
                this.intervals.push(
                  { text: this.$t("message.custom_day_cycle"), value: "custom-day-cycle" });
                this.intervals = [
                  { text: this.$t("message.weekly"), value: "week" },
                  { text: this.$t("message.bi_weekly"), value: "bi-week" },
                  { text: this.$t("message.monthly"), value: "month" },
                  { text: this.$t("message.bi_yearly"), value: "bi-year" },
                  { text: this.$t("message.yearly"), value: "year" },];
              } else if (this.paymentsModule == 'easypay') {
                this.intervals = [
                  { text: this.$t("message.weekly"), value: "week" },
                  { text: this.$t("message.monthly"), value: "month" }]
              }
            } else {
              this.types = [
                { text: this.$t("message.goods"), value: "good" },
                { text: this.$t("message.membership"), value: "good_membership" },
              ];
            }
          });
        Api()
          .get("admins/academy/" + this.$store.state.selectedAcademy)
          .then((response) => {
            this.currency = response.data.currency;
            this.currencyText = response.data.currency
              ? response.data.currency
              : "???";
          });
        if (this.productId == "new") {
          this.product = {
            taxBehavior: null,
            allowedCustomClasses: [],
            unlimited: false,
            allowedClassCount: {}
          };
          this.loading = false;
        } else {
          Api()
            .get(
              "admins/academy/" +
              this.$store.state.managedAcademy +
              "/products/" +
              this.productId
            )
            .then((response) => {
              this.product = response.data;
              if (!this.product.allowedClassCount || !this.product.allowedClassCount.interval) {
                this.product.allowedClassCount = {};
              } else {
                this.allowedClassCount = this.product.allowedClassCount.count;
                this.allowedClassCountInterval = this.product.allowedClassCount.interval;
                this.allowedClassCountSendEmail = this.product.allowedClassCount.sendEmail;
              }
              if (this.product.allowedClasses && this.product.allowedClasses.length)
                this.restrictAttendance = true;
              if (this.product.allowedCustomClasses && this.product.allowedCustomClasses.length)
                this.restrictAttendance = true;
              else
                this.product.allowedCustomClasses = [];
              if (this.product.allowedClassCount && this.product.allowedClassCount.interval)
                this.restrictAttendance = true;
              if (!this.product.taxBehavior)
                this.product.taxBehavior = null;
              if (this.product.amountDecimal > 0) {
                const amount = this.product.amount + "";
                this.price = amount.substring(0, amount.length - 2);
                this.priceDecimal = amount.substring(
                  amount.length - 2,
                  amount.length
                );
              } else {
                this.price = 0;
                this.priceDecimal = 0;
              }
              if (this.product.type != "service")
                this.getAltStripeAccounts();
              this.automaticTaxes = this.product.automaticTaxes;
              if (this.automaticTaxes)
                this.getTaxCodes();
              this.productImage = this.product.image;
              if (this.product.color) this.showColorPicker = true;
              this.loading = false;
              if (this.product.isMembership) {
                Api()
                  .get("documents/academy/" + this.$store.state.managedAcademy + "/contracts")
                  .then((response) => {
                    const data = response.data;
                    if (data) {
                      for (const c of data.contracts)
                        this.contracts.push({ value: c._id, text: c.name });
                      if (this.product.documentTemplate)
                        this.assignContract = true;
                    }
                  })
                  .catch((e) => {
                    if (e)
                      this.showAlert("error", this.$t("message.error_generic"));
                  });
                if (
                  this.product.amountStripe &&
                  this.product.amountStripe != this.product.amount
                ) {
                  this.showAlert(
                    "error",
                    this.$t("message.corrupted_item"),
                    this.$t("message.corrupted_item_explained"),
                    25000
                  );
                }
                for (const i of this.intervals) {
                  if (this.product.interval == i.value) {
                    this.intervalText = i.text;
                    break;
                  }
                }
              }
            })
            .catch((e) => {
              console.log("ERROR HERE", {e}, e);
              this.loading = false;
              if (e)
                this.showAlert("error", this.$t("message.error_generic"));
            });
        }
      }
    },
    initTaxCode(product) {
      product.taxCategory = 'txcd_99999999';
      if (product.type == 'service')
        product.taxCategory = 'txcd_20030000';
    },
    getProductInventory() {
      this.loadingInventory = true;
      Api()
        .get(
          "admins/academy/" + this.$store.state.managedAcademy + "/products/" + this.productId + "/inventory"
        )
        .then((response) => {
          this.inventory = response.data.data;
          this.loadingInventory = false;
        })
        .catch(() => {
          this.loadingInventory = false;
        });
    },
    addEditProduct() {
      if (this.paymentsModule == 'stripe' && !this.stripeReady && this.product.type == "service") {
        this.showAlert(
          "error",
          this.$t("message.need_connect_stripe_subscriptions"),
          8000
        );
        return;
      } else if (this.paymentsModule == 'easypay' && !this.paymentsReady) {
        this.showAlert(
          "error",
          this.$t("message.payments_not_ready"),
          8000
        );
        return;
      }
      if (!this.product.name || !this.product.type || this.price == null ||
        (this.product.type == 'service' && !this.product.interval)) {
        this.showAlert("error", this.$t("message.fill_all_params"));
        return;
      } else {
        this.updating = true;
        this.formMessage = null;
        if (this.priceDecimal == "") this.priceDecimal = "00";
        else if (this.priceDecimal.length == 1)
          this.priceDecimal = this.priceDecimal + "0";
        this.product.amount = new Number(this.price + this.priceDecimal);
        this.product.amountDecimal = new Number(
          this.price + "." + this.priceDecimal
        );
        if (this.product.amountDecimal == 0 && this.product.type == 'service') {
          this.showAlert("error", this.$t("message.recurrent_requires_amount"));
          return;
        }
        if (this.restrictAttendance && this.allowedClassCountInterval && !isNaN(this.allowedClassCount)) {
          this.product.allowedClassCount = {
            count: new Number(this.allowedClassCount).valueOf(),
            interval: this.allowedClassCountInterval, // month|week
            sendEmail: this.allowedClassCountSendEmail,
          };
        } else {
          this.product.allowedClassCount = null;
        }
        if (this.product._id) {
          Api()
            .patch(
              "admins/academy/" +
              this.$store.state.managedAcademy +
              "/products",
              this.product
            )
            .then((response) => {
              const data = response.data;
              if (data) {
                this.showAlert("success", this.$t("message.updated"));
                this.getProductInventory();
                this.updating = false;
              }
            })
            .catch((e) => {
              if (e)
                this.showAlert(
                  "error",
                  this.$t("message.error_generic")
                );
            });
        } else {
          this.updating = true;
          Api()
            .post(
              "admins/academy/" +
              this.$store.state.managedAcademy +
              "/products",
              this.product
            )
            .then((response) => {
              const data = response.data;
              if (data && data._id) {
                this.productId = data._id;
                this.updating = false;
                this.initPage();
                this.updateOnboardState();
              }
            })
            .catch((e) => {
              if (e)
                this.showAlert(
                  "error",
                  this.$t("message.error_generic")
                );
            });
        }
      }
    },
    getAltStripeAccounts() {
      Api()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/altstripeaccounts"
        )
        .then((response) => {
          if (response.data && response.data.accounts)
            this.altStripeAccounts = response.data.accounts;
        });
    },
    updateOnboardState() {
      if (!this.onboardingStepComplete) {
        completeOnboardingStep({
          step: "setupProductsMemberships",
          managedAcademy: this.$store.state.managedAcademy,
          store: this.$store
        }).then(({ stepState }) => {
          this.onboardingStepComplete = !!stepState?.setupProductsMemberships;
        });
      }
    },
    showDeleteProductDialog() {
      this.formMessage = null;
      this.deleteProductDialog = true;
    },
    deleteProduct() {
      this.deletingProduct = true;
      Api()
        .delete(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/products/" +
          this.productId
        )
        .then((response) => {
          if (response) this.navigateTo({ name: "productsmemberships" });
        })
        .catch((e) => {
          this.deletingProduct = false;
          if (e)
            this.showAlert("error", this.$t("message.error_generic"));
        });
    },
  },
};
</script>

